var map = {
	"./ad.png": 15871,
	"./ae.png": 18934,
	"./af.png": 32909,
	"./ag.png": 79012,
	"./ai.png": 75130,
	"./al.png": 65639,
	"./am.png": 13150,
	"./an.png": 98901,
	"./ao.png": 62988,
	"./ar.png": 60377,
	"./as.png": 54128,
	"./at.png": 39503,
	"./au.png": 57958,
	"./aw.png": 18036,
	"./ax.png": 60307,
	"./az.png": 85825,
	"./ba.png": 83155,
	"./bb.png": 37400,
	"./bd.png": 40814,
	"./be.png": 86391,
	"./bf.png": 28284,
	"./bg.png": 11173,
	"./bh.png": 16642,
	"./bi.png": 37771,
	"./bj.png": 66480,
	"./bm.png": 62351,
	"./bn.png": 87860,
	"./bo.png": 20893,
	"./br.png": 55848,
	"./bs.png": 95793,
	"./bt.png": 59678,
	"./bv.png": 62540,
	"./bw.png": 45429,
	"./by.png": 58779,
	"./bz.png": 3744,
	"./ca.png": 81804,
	"./catalonia.png": 54480,
	"./cc.png": 83550,
	"./cd.png": 24561,
	"./cf.png": 11971,
	"./cg.png": 94394,
	"./ch.png": 94253,
	"./ci.png": 54308,
	"./ck.png": 12630,
	"./cl.png": 12457,
	"./cm.png": 57632,
	"./cn.png": 35963,
	"./co.png": 21746,
	"./cr.png": 89303,
	"./cs.png": 46286,
	"./cu.png": 14136,
	"./cv.png": 88627,
	"./cx.png": 83837,
	"./cy.png": 62708,
	"./cz.png": 81615,
	"./de.png": 53041,
	"./dj.png": 41558,
	"./dk.png": 19647,
	"./dm.png": 15817,
	"./do.png": 16027,
	"./dz.png": 80582,
	"./ec.png": 37948,
	"./ee.png": 53962,
	"./eg.png": 47064,
	"./eh.png": 72015,
	"./england.png": 26953,
	"./er.png": 55093,
	"./es.png": 72204,
	"./et.png": 2371,
	"./europeanunion.png": 61902,
	"./fam.png": 52522,
	"./fi.png": 22903,
	"./fj.png": 15324,
	"./fk.png": 51237,
	"./fm.png": 12723,
	"./fo.png": 38241,
	"./fr.png": 31428,
	"./ga.png": 89176,
	"./gb.png": 63667,
	"./gd.png": 97573,
	"./ge.png": 80060,
	"./gf.png": 68791,
	"./gh.png": 10713,
	"./gi.png": 94960,
	"./gl.png": 5853,
	"./gm.png": 68372,
	"./gn.png": 90831,
	"./gp.png": 50129,
	"./gq.png": 1736,
	"./gr.png": 63715,
	"./gs.png": 73882,
	"./gt.png": 25941,
	"./gu.png": 14316,
	"./gw.png": 5566,
	"./gy.png": 37120,
	"./hk.png": 77611,
	"./hm.png": 48829,
	"./hn.png": 67622,
	"./hr.png": 84794,
	"./ht.png": 50271,
	"./hu.png": 8565,
	"./id.png": 38599,
	"./ie.png": 62814,
	"./il.png": 22399,
	"./in.png": 84013,
	"./io.png": 20772,
	"./iq.png": 70154,
	"./ir.png": 19137,
	"./is.png": 46424,
	"./it.png": 26039,
	"./jm.png": 11527,
	"./jo.png": 60565,
	"./jp.png": 97154,
	"./ke.png": 848,
	"./kg.png": 49570,
	"./kh.png": 80165,
	"./ki.png": 67100,
	"./km.png": 76216,
	"./kn.png": 50707,
	"./kp.png": 56333,
	"./kr.png": 71039,
	"./kw.png": 61445,
	"./ky.png": 43884,
	"./kz.png": 63943,
	"./la.png": 40221,
	"./lb.png": 42662,
	"./lc.png": 81679,
	"./li.png": 30501,
	"./lk.png": 5719,
	"./lr.png": 3638,
	"./ls.png": 81727,
	"./lt.png": 23072,
	"./lu.png": 77897,
	"./lv.png": 12754,
	"./ly.png": 64757,
	"./ma.png": 31958,
	"./mc.png": 73636,
	"./md.png": 55291,
	"./me.png": 41074,
	"./mg.png": 76960,
	"./mh.png": 21191,
	"./mk.png": 1132,
	"./ml.png": 31299,
	"./mm.png": 13722,
	"./mn.png": 43889,
	"./mo.png": 46024,
	"./mp.png": 943,
	"./mq.png": 61926,
	"./mr.png": 3165,
	"./ms.png": 82036,
	"./mt.png": 27947,
	"./mu.png": 6818,
	"./mv.png": 55001,
	"./mw.png": 58096,
	"./mx.png": 8631,
	"./my.png": 65614,
	"./mz.png": 37413,
	"./na.png": 78455,
	"./nc.png": 7237,
	"./ne.png": 73331,
	"./nf.png": 98840,
	"./ng.png": 71553,
	"./ni.png": 495,
	"./nl.png": 6370,
	"./no.png": 20377,
	"./np.png": 15230,
	"./nr.png": 23980,
	"./nu.png": 73379,
	"./nz.png": 73188,
	"./om.png": 29452,
	"./pa.png": 28233,
	"./pe.png": 93677,
	"./pf.png": 78262,
	"./pg.png": 32063,
	"./ph.png": 68648,
	"./pk.png": 30627,
	"./pl.png": 81228,
	"./pm.png": 92853,
	"./pn.png": 72478,
	"./pr.png": 63618,
	"./ps.png": 27275,
	"./pt.png": 35284,
	"./pw.png": 57743,
	"./py.png": 28801,
	"./qa.png": 16034,
	"./re.png": 32551,
	"./ro.png": 99821,
	"./rs.png": 36385,
	"./ru.png": 37399,
	"./rw.png": 65733,
	"./sa.png": 82236,
	"./sb.png": 89815,
	"./sc.png": 90318,
	"./scotland.png": 47240,
	"./sd.png": 5153,
	"./se.png": 67672,
	"./sg.png": 47722,
	"./sh.png": 58493,
	"./si.png": 37364,
	"./sj.png": 58831,
	"./sk.png": 77286,
	"./sl.png": 79705,
	"./sm.png": 73456,
	"./sn.png": 87275,
	"./so.png": 13122,
	"./sr.png": 84967,
	"./st.png": 15569,
	"./sv.png": 42211,
	"./sy.png": 98340,
	"./sz.png": 35199,
	"./tc.png": 18295,
	"./td.png": 43128,
	"./tf.png": 62410,
	"./tg.png": 17619,
	"./th.png": 91700,
	"./tj.png": 71590,
	"./tk.png": 10607,
	"./tl.png": 67760,
	"./tm.png": 64665,
	"./tn.png": 16482,
	"./to.png": 37611,
	"./tr.png": 12542,
	"./tt.png": 55688,
	"./tv.png": 23386,
	"./tw.png": 40963,
	"./tz.png": 41622,
	"./ua.png": 89726,
	"./ug.png": 62600,
	"./um.png": 4626,
	"./us.png": 39484,
	"./uy.png": 34534,
	"./uz.png": 15741,
	"./va.png": 38975,
	"./vc.png": 51565,
	"./ve.png": 35355,
	"./vg.png": 35145,
	"./vi.png": 7591,
	"./vn.png": 32424,
	"./vu.png": 14347,
	"./wales.png": 68854,
	"./wf.png": 78439,
	"./ws.png": 9994,
	"./ye.png": 27054,
	"./yt.png": 17255,
	"./za.png": 96939,
	"./zm.png": 99479,
	"./zw.png": 61901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44387;